import Locale from './Locale';
import logger from './Logger';
import { ChemicalType, ChemicalTypeSalt } from "../types";
import { ChemicalDosingUnit } from "../config"
import { PoolsideError } from './Error';
// import { localeMeasurementSystems } from ".";

/**
 * Returns human readable name of CHEMICAL_DOSING_UNIT constant.
 * @param {string} key Constant to look up
 */
export function getChemicalDosingUnitName(key: ChemicalDosingUnit): string | undefined {
    if (typeof key === 'undefined') return;
    switch (key) {
    case 'SALT_PERCENT': return Locale.gettext('Salt Percent');
    case 'TIME': return Locale.gettext('Time');
    // Treating OZ as it was named as VOLUME
    case 'OZ': return Locale.gettext('Volume');
    }
    logger.warn('There is no translation defined for chemical dosing uint:', key)
    return key;
}

export function getAmountName(key: ChemicalDosingUnit): string | undefined {
    if (typeof key === 'undefined') return;
    switch (key) {
    // case ChemicalDosingUnit.SALT_PERCENT: return Locale.gettext('%');
    case 'SALT_PERCENT': return Locale.gettext('%');
    // case ChemicalDosingUnit.TIME: return Locale.pgettext('Abbreviation of minute. ', 'm');
    case 'TIME': return Locale.pgettext('Abbreviation of minute. ', 'm');
    // Treating OZ as it was named as VOLUME
    // case ChemicalDosingUnit.OZ: return Locale.volumeUnit === localeMeasurementSystems.IMPERIAL ?
    case 'OZ': return Locale.volumeUnit === 'imperial' ?
        Locale.gettext('oz') :
        Locale.gettext('mL');
    }
    logger.warn('There is no translation defined for chemical dosing amount:', key)
    return key;
}

export function getChemicalTypeName(key: ChemicalType | typeof ChemicalTypeSalt | undefined): string {
    switch (key) {
    case ChemicalType.Chlorine: return Locale.gettext('Liquid Chlorine');
    case ChemicalType.Co2: return Locale.gettext('CO2');
    case ChemicalType.MuriaticAcid: return Locale.gettext('Muriatic Acid');
    case ChemicalType.Base: return Locale.gettext('Base');
    case ChemicalTypeSalt: return Locale.gettext('Salt Chlorine');
    }
    if (typeof key === 'string' && key !== '') {
        logger.warn('There is no translation defined for chemical type:', key);
        return key;
    } else {
        return '?';
    }
}

export enum StartDosingError {
    NONE = "NONE",
    ALREADY_DOSING = "ALREADY_DOSING",
    CHEMISTRY_DEVICES_NOT_IN_FLOW = "CHEMISTRY_DEVICES_NOT_IN_FLOW",
    DOSING_DISABLED = "DOSING_DISABLED",
    UNKNOWN = "UNKNOWN",
};

export function processOneTimeDosingResult(res: { Error?: string, Success?: boolean }, successHandler: (successText: string) => void, confirmHandler: (denyReason: StartDosingError) => void) {
    if (res.Success) {
        successHandler(Locale.gettext("Dosing has started"));
    } else {
        switch(res.Error) {
        case StartDosingError.ALREADY_DOSING:
        case StartDosingError.DOSING_DISABLED:
            confirmHandler(res.Error);
            break;
        case StartDosingError.CHEMISTRY_DEVICES_NOT_IN_FLOW:
            throw new PoolsideError(
                "Could not start dosing: " + res.Error,
                Locale.gettext("Could not start dosing.  There are no chemistry devices in the flow.  You might need to first turn on filtering."),
                "Result: " + JSON.stringify(res)
            );
            break;
        case StartDosingError.UNKNOWN:
            throw new PoolsideError(
                "Controller reported UNKNOWN for the Device.startDosing request",
                Locale.gettext("Could not start dosing.  An unknown error response was received.") + " (1)",
                "Result: " + JSON.stringify(res)
            );
            break;
        default:
            throw new PoolsideError(
                "Controller reported an unknown error for the Device.startDosing request",
                Locale.gettext("Could not start dosing.  An unknown error response was received.") + " (2)",
                "Result: " + JSON.stringify(res)
            );
            break;
        }
    }
}
